import { toast, Bounce } from "react-toastify"
import { post, patch, del } from "../../../api/axios"
import { toastApiError } from "../../../helpers/apiError"
import endpoints from "../../../api/endpoints"
import { toOngoingRolePayload } from "../../../helpers/ongoingRoleForm"
import { applyFormErrors } from "./onboardingProjectHelpers"

export const ongoingRoleDraftHasContent = values => Boolean(values.roleType)

export const collectOngoingRoles = async ({ items, formik, editingIndex }) => {
  let final = [...items]

  if (editingIndex !== null) {
    const errors = await formik.validateForm(formik.values)
    if (Object.keys(errors).length > 0) {
      applyFormErrors(formik, errors)
      return null
    }
    final[editingIndex] = formik.values
    return final
  }

  if (ongoingRoleDraftHasContent(formik.values)) {
    const errors = await formik.validateForm(formik.values)
    if (Object.keys(errors).length > 0) {
      applyFormErrors(formik, errors)
      return null
    }
    final = [...final, formik.values]
  }

  return final
}

export const submitOngoingRoles = async ({ roles, onSuccess }) => {
  const newRoles = roles.filter(role => !role.id)

  if (!newRoles.length) {
    onSuccess?.(roles)
    return true
  }

  const res = await post(endpoints.onGoingRole, {
    roles: newRoles.map(toOngoingRolePayload),
  })

  if (res?.data?.success) {
    toast.success(res?.data?.message || "Saved successfully", {
      position: "bottom-center",
      theme: "colored",
      transition: Bounce,
    })

    const created = Array.isArray(res?.data?.result)
      ? res.data.result
      : [res?.data?.result].filter(Boolean)
    const createdByRole = new Map()
    newRoles.forEach((role, i) => createdByRole.set(role, created[i]))

    const nextRoles = roles.map(role =>
      role.id || !createdByRole.has(role)
        ? role
        : { ...role, id: createdByRole.get(role)?.id },
    )

    onSuccess?.(nextRoles)
    return true
  }

  toastApiError(res, "Failed to save roles")
  return false
}

export const updateOngoingRole = async ({ role }) => {
  if (!role?.id) return false

  try {
    const res = await patch(endpoints.onGoingRole, {
      roles: [toOngoingRolePayload(role)],
    })

    if (res?.data?.success) {
      toast.success(res?.data?.message || "Role updated", {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      })
      return true
    }

    toastApiError(res, "Failed to update role")
    return false
  } catch (error) {
    toastApiError(error, "Failed to update role")
    return false
  }
}

export const deleteOngoingRole = async roleId => {
  if (!roleId) return true

  try {
    const res = await del(endpoints.deleteOnGoingRole(roleId))

    if (res?.data?.success) {
      toast.success(res?.data?.message || "Role deleted", {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      })
      return true
    }

    toastApiError(res, "Failed to delete role")
    return false
  } catch (error) {
    toastApiError(error, "Failed to delete role")
    return false
  }
}
